import { axiosInstance } from '../../axios';
import { AdminMcpServer } from './mcp.interface';

export function fetchMcpServers() {
  return axiosInstance
    .get<AdminMcpServer[]>('/api/admin/mcp')
    .then((response) => response.data);
}

export function restartMcpServer(id: string) {
  return axiosInstance
    .post<boolean>(`/api/admin/mcp/${id}/restart`)
    .then((response) => response.data);
}
